import { render, staticRenderFns } from "./InfoCoordInput.vue?vue&type=template&id=676e6b3e&"
import script from "./InfoCoordInput.vue?vue&type=script&lang=ts&"
export * from "./InfoCoordInput.vue?vue&type=script&lang=ts&"
import style0 from "./InfoCoordInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VRow,VSpacer})
